import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import DropDownMenu from '../components/DropDownMenu';
import { fetchMissionById, updateMissionById } from '../../services2/pmissions.service';
import EditMissionsPagesSection from './components/EditMissionsPagesSection';
import EditMissionsQuestionSection from './components/EditMissionsQuestionSection';
import FileDropzone from './components/UploadFileDropZone';
import RemoveSvg from '../../svg/admin/Remove';
import MDEditor from '@uiw/react-md-editor';
import EditPageDetails from './MissionPageDetails';
import _ from 'lodash';
import { uploadPhoto } from '../../services2/s3.service';

function Component(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setdata] = useState(null)
  const [isLoading, setisLoading] = useState(false)

  const fetchData = async () => {
    if (isLoading) return
    setisLoading(true)
    let result = await fetchMissionById(props.token.token, id);
    if (result.result) {
      setdata(result.result)
    } else {
      alert('Fetch data error')
    }
    setisLoading(false)
  }

  const handleSave = async () => {
    if (isLoading) return
    setisLoading(true)
    let result = await updateMissionById(props.token.token, id, {
      name: data.name || '',
      category: data.category || '',
      mission: data.mission || '',
      description: data.description || '',
      time: Number(data.time) || 60,
      status: data.status || '未公開',
      consent: data.consent || '',
      consentRemarks: data.consentRemarks || '',
      pages: data.pages || [],
      questions: data.questions || [],
      questionnaires: data.questionnaires || [],
      photo: data.photo || '',
    });
    if (result.errno) {
      alert(result.message)
    } else {
      alert('儲存成功')
    }
    setisLoading(false)
  }

  const handleUpdateField = (field) => (e) => {
    setdata({ ...data, [field]: e.target.value })
  }

  useEffect(() => {
    fetchData()
  }, [id])


  {/*pages handler*/ }
  const handleSectionCardOrder = (oldLayout, newLayout) => {
    let array = []
    newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
    for (let i of newLayout) {
      let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
      array.push(data.pages[oldIndex]);
    }
    let d = { ...data };
    d.pages = array;
    setdata(d);
  }
  const handleSectionAddCard = () => {
    let d = { ...data };
    let pages = [...d.pages]
    pages.push({ name: '新頁面', id: Date.now() })
    d.pages = pages
    setdata(d);
  }
  const handleSectionDeleteCard = (card, cardIndex) => {
    let d = { ...data }
    let pages = d.pages;
    pages.splice(cardIndex, 1);
    d.pages = pages;
    setdata(d)
  }
  const handleSectionEditKey = (card, cardIndex, key, value) => {
    let d = { ...data };
    d.pages[cardIndex][key] = value
    setdata(d);
  }
  {/*questions handler*/ }


  {/*questions handler*/ }
  const handleSectionQuestionOrder = (oldLayout, newLayout) => {
    let array = []
    newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
    for (let i of newLayout) {
      let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
      array.push(data.questions[oldIndex]);
    }
    let d = { ...data };
    d.questions = array;
    setdata(d);
  }
  const handleSectionAddQuestion = () => {
    let d = { ...data };
    let questions = [...d.questions]
    questions.push({ dialog: '新對話', id: Date.now() })
    d.questions = questions
    setdata(d);
  }
  const handleSectionDeleteQuestion = (card, cardIndex) => {
    let d = { ...data }
    let questions = d.questions;
    questions.splice(cardIndex, 1);
    d.questions = questions;
    setdata(d)
  }
  const handleSectionEditQuestion = (card, cardIndex, key, value) => {
    let d = { ...data };
    d.questions[cardIndex][key] = value
    setdata(d);
  }
  {/*questions handler*/ }

  {/*questionnaires handler*/ }
  const handleSectionQuestionnaireOrder = (oldLayout, newLayout) => {
    let array = []
    newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
    for (let i of newLayout) {
      let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
      array.push(data.questionnaires[oldIndex]);
    }
    let d = { ...data };
    d.questionnaires = array;
    setdata(d);
  }
  const handleSectionAddQuestionnaire = () => {
    let d = { ...data };
    let questionnaires = [...(d.questionnaires||[])]
    questionnaires.push({ id: Date.now() })
    d.questionnaires = questionnaires
    setdata(d);
  }
  const handleSectionDeleteQuestionnaire = (card, cardIndex) => {
    let d = { ...data }
    let questionnaires = d.questionnaires;
    questionnaires.splice(cardIndex, 1);
    d.questionnaires = questionnaires;
    setdata(d)
  }
  const handleSectionEditQuestionnaire = (card, cardIndex, key, value) => {
    let d = { ...data };
    d.questionnaires[cardIndex][key] = value
    setdata(d);
  }
  {/*questionnaires handler*/ }

  {/*handle File upload*/ }
  const onDropImageFile = async (files) => {
    if (files.length > 1) {
      alert(`Only one file is allowed.`)
      return
    }
    const file = files[0]
    if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
      alert(`File type ${file.type} is not allowed`)
      return
    }
    if (file.size > 1024 * 1024 * 2) {
      alert(`File size must be within 2 MB`)
      return
    }

    let formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('json', JSON.stringify({}));
    setisLoading(true);
    let res = await uploadPhoto(props.token?.token, formData, id, 'cover')
    if (res.errno) {
      alert(res.message)
    } else {
      if (res.result) {
        let filepath = res.result
        setdata({ ...data, photo: filepath });
      }
    }
    setisLoading(false);
  }
  const handleRemoveImage = async () => {
    setisLoading(true);
    setdata({ ...data, photo: '' });
    setisLoading(false);
  }
  {/*end of handle File upload*/ }

  const [isEditingPage, setisEditingPage] = useState(null)

  if (isEditingPage) return (
    <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]'>
      <div className='absolute inset-0 flex justify-center items-center'>
        <EditPageDetails onSave={handleSave} onEdit={
          (key, value) => {
            let d = { ...data };
            d.pages[_.findIndex(d.pages, { id: isEditingPage.id })][key] = value
            setdata(d);
          }} title={data?.name} pages={data.pages} id={id} data={isEditingPage} close={() => { setisEditingPage(null) }} />
      </div>
      {isLoading && <LoadingPage />}
    </div>
  )
  return (
    <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
      {/*buttons*/}
      <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
        <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate('/platform2/missions') }}>{`<`} 返回</div>
        <div className='flex flex-row gap-[8px] flex-wrap '>
          {/* <div className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>刪除</div> */}
          {/* <div className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>複製</div> */}
          <div onClick={handleSave} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>儲存</div>
        </div>
      </div>
      {/*end of buttons*/}

      <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap'>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>閲讀任務名稱</div>
          <input value={data?.name || ''} onChange={handleUpdateField('name')} placeholder='閲讀任務名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />

          <div className='w-full flex flex-row flex-wrap gap-[8px] mt-[16px]'>
            <div className='flex flex-col flex-[1] gap-[8px]'>
              <div className='font-[700]'>分類</div>
              <DropDownMenu value={data?.category || '--- 無 ---'} select={(c) => { handleUpdateField('category')({ target: { value: c } }) }} options={['分類 1', '分類 2', '分類 3']} />
            </div>
            <div className='flex flex-col flex-[1] gap-[8px]'>
              <div className='font-[700]'>任務</div>
              <input value={data?.mission || ''} onChange={handleUpdateField('mission')} placeholder='任務' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
            </div>
          </div>

          <div className='font-[700] mt-[16px]'>同意書</div>
          {/* <textarea value={data?.consent} onChange={handleUpdateField('consent')}  placeholder='同意書' className='rounded-[7px] px-[8px] py-[4px] font-[400] min-h-[100px]'/> */}
          <MDEditor data-color-mode="light"
            className='bg-white'
            value={data?.consent || ''}
            onChange={(v) => { handleUpdateField('consent')({ target: { value: v } }) }}
          />
          <div className='font-[700] mt-[16px]'>同意書備註</div>
          {/* <textarea value={data?.consent} onChange={handleUpdateField('consent')}  placeholder='同意書' className='rounded-[7px] px-[8px] py-[4px] font-[400] min-h-[100px]'/> */}
          <MDEditor data-color-mode="light"
            className='bg-white'
            value={data?.consentRemarks || ''}
            onChange={(v) => { handleUpdateField('consentRemarks')({ target: { value: v } }) }}
          />

          <div className='font-[700] mt-[16px]'>簡介</div>
          {/* <textarea value={data?.description} onChange={handleUpdateField('description')}  placeholder='簡介' className='rounded-[7px] px-[8px] py-[4px] font-[400] min-h-[100px]'/> */}
          <MDEditor data-color-mode="light"
            className='bg-white'
            value={data?.description || ''}
            onChange={(v) => { handleUpdateField('description')({ target: { value: v } }) }}
          />
          {/* <MDEditor.Markdown source={data?.description||''} style={{ whiteSpace: 'pre-wrap',color:"black",backgroundColor:"white",}} /> */}
        </div>

        <div className='flex-[2] flex flex-col min-w-[300px] gap-[8px]'>
          <div className='font-[700]'>封面圖片</div>
          {data?.photo && <div className='relative w-full'>
            {
              data?.photo
                ? <img style={{ height: 200, width: 200, objectFit: 'contain' }} src={data?.photo} alt='image' />
                : <div>
                  {/* <PicFileLogoSvg/> */}
                </div>
            }
            <div onClick={handleRemoveImage} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
              <RemoveSvg />
            </div>
          </div>}
          <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
            <FileDropzone onDropFile={onDropImageFile} data={data} />
          </div>

          <div className='font-[700] mt-[16px]'>時間</div>
          <DropDownMenu select={(time) => {
            setdata({ ...data, time: Number(time.split('分鐘')[0]) })
          }} options={['10分鐘', '20分鐘', '30分鐘', '40分鐘', '50分鐘', '60分鐘']} value={`${data?.time || '-'} 分鐘`} />

          <div className='font-[700] mt-[16px]'>狀態</div>
          <DropDownMenu select={(status) => {
            setdata({ ...data, status })
          }} options={['啟動中', '未公開']} value={`${data?.status || '-'}`} />

        </div>
      </div>

      <div className='font-[700] mt-[16px]'>頁面內容</div>
      <div className='w-full bg-white rounded-[10px] py-[16px] flex flex-col gap-[4px]'>
        <EditMissionsPagesSection
          data={data}
          updateOrder={handleSectionCardOrder}
          onAddCard={handleSectionAddCard}
          onEditKey={handleSectionEditKey}
          onDelete={handleSectionDeleteCard}
          onClickPage={(page) => { setisEditingPage(page) }}
        />
      </div>

      <div className='font-[700] mt-[16px]'>任務對話</div>
      <div className='w-full bg-white rounded-[10px] py-[16px] flex flex-col gap-[4px]'>
        <EditMissionsQuestionSection
          data={data}
          updateOrder={handleSectionQuestionOrder}
          onAddCard={handleSectionAddQuestion}
          onEditKey={handleSectionEditQuestion}
          onDelete={handleSectionDeleteQuestion}
        />
      </div>

      {isLoading && <LoadingPage />}
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
